import { Injectable } from '@angular/core';
import { LZStringService } from '../l-z-string/l-z-string.service';
import { LocalStorageCommonService } from './local-storage-common.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageDisclaimerService {
    public constructor(
        private readonly localStorageCommonService: LocalStorageCommonService,
        private readonly LZString: LZStringService,
    ) {}

    public saveDisclaimerToLocalStorage(id: string, disclaimer: string): void {
        const compressed = this.LZString.compress(disclaimer);
        this.localStorageCommonService.storageSet(id, compressed);
    }

    public getDisclaimerFromLocalStorage(id: string): string {
        const compressed = this.localStorageCommonService.storageGet<string>(id);
        if (compressed) {
            const decompressed = this.LZString.decompress(compressed);
            return decompressed;
        } else {
            return '';
        }
    }
}
